export enum InputType {
    EMAIL = "EMAIL",
    EMAIL_CODE = "EMAIL_CODE"
}